var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1133 18.0717C12.145 18.1506 12.2 18.2179 12.2711 18.2646C12.3421 18.3113 12.4257 18.3352 12.5107 18.333C12.5957 18.3309 12.678 18.3027 12.7465 18.2524C12.8151 18.2021 12.8666 18.1321 12.8942 18.0517L18.3108 2.21833C18.3375 2.14449 18.3426 2.06459 18.3255 1.98796C18.3084 1.91134 18.2699 1.84116 18.2144 1.78565C18.1588 1.73013 18.0887 1.69158 18.012 1.67449C17.9354 1.65741 17.8555 1.6625 17.7817 1.68917L1.94833 7.10583C1.86791 7.13341 1.79785 7.18493 1.74756 7.25348C1.69727 7.32202 1.66914 7.40431 1.66697 7.4893C1.66479 7.57429 1.68866 7.65791 1.73538 7.72894C1.7821 7.79997 1.84943 7.85501 1.92833 7.88667L8.53667 10.5367C8.74557 10.6203 8.93538 10.7454 9.09464 10.9044C9.2539 11.0633 9.37932 11.2529 9.46333 11.4617L12.1133 18.0717Z",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#87958F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.2117 1.78917L9.095 10.905",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#87958F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.4657066f656f54fa1cb1371d8a0cdf70.svg";
export { ForwardRef as ReactComponent };